import api from 'Application/api/api';

const getIndustriesByIds = (signal, ids) =>
	api.get('/industries/by-ids', {
		params: {
			ids,
		},
		signal,
	});

export default getIndustriesByIds;
